import http from '../config'

const project_agent = {
  // 获取卡权益
  getCardBenefit(params) {
    return http({
      url: 'user/agent/card_benefit',
      params
    })
  },
  // 获取体检预约套餐链接
  getPackageUrl() {
    return http({
      url: 'user/agent/get_benefit'
    })
  }
}
export default project_agent
